var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details-container"},[(_vm.views)?_c('div',{staticClass:"views-block"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'eye']}}),_c('span',[_vm._v(_vm._s(_vm.views))])],1):_vm._e(),_c('div',{staticClass:"publish-date"},[_c('span',{class:{ 'text--shadow': _vm.shadow }},[_vm._v(_vm._s(_vm._f("formatDate")(_vm.date)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }